import type { Feature } from '@exodus/dependency-types';
import fiatRampFactory from '@exodus/fiat-ramp';

import fiatProviderAtomDefinition from './atoms/provider.js';
import fiatRampProviderPluginDefinition from './plugins/provider.js';
import fiatRampWidgetPluginDefinition from './plugins/widget.js';

type Config = NonNullable<
  NonNullable<Parameters<typeof fiatRampFactory>[0]>['configOverrides']
>;

const fiatRampDefinition = (config: Config) => {
  const feature = fiatRampFactory({ configOverrides: config });

  return {
    ...feature,
    definitions: [
      ...feature.definitions,
      { definition: fiatRampProviderPluginDefinition },
      {
        definition: fiatRampWidgetPluginDefinition,
        config: { serverUrl: config.FIAT_SERVER_URL },
      },
      {
        definition: fiatProviderAtomDefinition,
        storage: { namespace: 'fiat' },
      },
    ],
  } satisfies Feature;
};

export default fiatRampDefinition;
